import { CellContext } from "@tanstack/react-table";
import { Intent, SearchType, Trend } from "../../../__generated__/gql/graphql";
import { Asterisk, Target } from "../../../ui/Icon/Icon";
import styles from "./SearchTypeCell.module.scss";
import Truncate from "../../../ui/Truncate/Truncate";
import { Link } from "react-router-dom";
import urls from "../../../routes";
import Tooltip from "../../../ui/Tooltip/Tooltip";

const SearchTypeIcons = {
  [SearchType.Keyword]: <Asterisk size="xsmall" />,
  [SearchType.CompetitorGap]: <Target size="xsmall" />,
};

function SearchTypeCell({
  cell,
}: CellContext<
  {
    id: string;
    keyword: string;
    searchType?: SearchType | null;
    searchValue?: string | null;
    difficulty?: number | null;
    searchVolume?: number | null;
    intent?: Intent | null;
    trend?: Trend[] | null;
  },
  unknown
>) {
  return (
    <div className={styles.container}>
      {cell.row.original.searchType && cell.row.original.searchValue ? (
        <Tooltip
          content={
            cell.row.original.searchType === SearchType.Keyword
              ? `This keyword was found by searching the keyword "${cell.row.original.searchValue}". Click to find more keywords for this topic.`
              : `This keyword was found by searching competitor gaps. Click to find more keyword gaps with your competitor "${cell.row.original.searchValue}".`
          }
        >
          <Link
            className={styles.link}
            to={`${
              cell.row.original.searchType === SearchType.CompetitorGap
                ? urls.keywords.competitorGap
                : urls.keywords.searchByKeyword
            }?value=${encodeURIComponent(cell.row.original.searchValue)}`}
          >
            {SearchTypeIcons[cell.row.original.searchType]}
            <Truncate className={styles.value} hideTooltip>
              {cell.row.original.searchValue}
            </Truncate>
          </Link>
        </Tooltip>
      ) : (
        "-"
      )}
    </div>
  );
}

export default SearchTypeCell;
